// ===== SIMPLE SHOPIFY CART =====

// Global cart object
window.ShopifyCart = {

  // Initialize cart
  init() {
    console.log('ShopifyCart.init() called');
    this.bindEvents();
    this.updateCartCount();
  },

  // Bind all events
  bindEvents() {
    // Add to cart button
    document.addEventListener('click', (e) => {
      if (e.target.closest('.add-to-cart-btn')) {
        e.preventDefault();
        this.addToCart();
      }
    });

    // Open cart modal (link or whole bag container)
    document.addEventListener('click', (e) => {
      const openCartTrigger = e.target.closest('.js-open-cart, .es-bag-container');
      if (openCartTrigger) {
        e.preventDefault();
        this.openCart();
      }
    });

    // Close cart modal
    document.addEventListener('click', (e) => {
      if (e.target.closest('.js-close-cart')) {
        e.preventDefault();
        this.closeCart();
      }
    });

    // Variant selection
    document.addEventListener('change', (e) => {
      if (e.target.name === 'variant') {
        this.handleVariantChange(e.target);
      }
    });

    // Quantity input changes
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('quantity__input')) {
        const variantId = e.target.dataset.variantId;
        const newQuantity = parseInt(e.target.value);
        if (variantId && newQuantity >= 0) {
          this.updateQuantityDirect(variantId, newQuantity);
        }
      }
    });

    // Pre-fill zip code on checkout
    document.addEventListener('click', (e) => {
      const checkoutBtn = e.target.closest('.cart__checkout-button');
      if (checkoutBtn) {
        e.preventDefault();
        window.location.href = '/checkout?checkout[shipping_address][zip]=00000';
      }
    });
  },

  // Handle variant change
  handleVariantChange(variantInput) {
    console.log('Variant changed:', variantInput.value);
    const form = document.getElementById('product-form');
    if (form) {
      const formIdInput = form.querySelector('input[name="id"]');
      if (formIdInput) {
        formIdInput.value = variantInput.value;
      }
    }
  },

  // Add item to cart
  async addToCart() {
    console.log('Adding to cart...');

    const selectedVariant = document.querySelector('input[name="variant"]:checked');
    const sizeField = document.getElementById('message');
    const sizeProperty = sizeField ? sizeField.value.trim() : '';


    if (!selectedVariant) {
      this.showMessage('Please select a size', 'error');
      return;
    }

    if (!sizeProperty) {
      if (sizeField) {
        sizeField.setAttribute('aria-invalid', 'true');
        sizeField.focus();
        sizeField.reportValidity();
      }
      this.showMessage('Please fill in the size field', 'error');
      return;
    }

    if (sizeField) {
      sizeField.removeAttribute('aria-invalid');
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: selectedVariant.value,
          quantity: 1,
          properties: {
            'My Size': sizeProperty
          }
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Added to cart:', result);

        this.updateCartCount();
        this.showMessage('Added to cart!');
        this.openCart();
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showMessage('Failed to add to cart', 'error');
    }
  },

  // Update cart count in header
  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count || 0;
        });

        // Update cart total if on cart page
        const cartTotalElement = document.querySelector('.totals__subtotal-value');
        if (cartTotalElement) {
          cartTotalElement.textContent = this.formatMoney(cart.total_price);
        }

        // Show empty cart message if needed
        if (cart.item_count === 0) {
          this.showEmptyCartMessage();
        } else {
          // Show the main cart title when cart has items
          const mainCartTitle = document.querySelector('.cart > h1');
          if (mainCartTitle) {
            mainCartTitle.style.display = 'block';
          }

          // Show checkout button when cart has items
          const checkoutButton = document.querySelector('.cart__checkout-button');
          if (checkoutButton) {
            checkoutButton.style.display = 'block';
          }

          // Show cart footer when cart has items
          const cartFooter = document.querySelector('.cart__footer');
          if (cartFooter) {
            cartFooter.style.display = 'block';
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  },

  // Format money
  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: '₴'
    }).format(cents / 100);
  },

  // Show empty cart message
  showEmptyCartMessage() {
    const cartItems = document.querySelector('.cart__items');
    if (cartItems) {
      cartItems.innerHTML = `
        <div class="cart__empty-text">
          <h1>Cart</h1>
          <p>Your cart is currently empty.</p>
          <a href="/collections" class="button">
            Continue Shopping
          </a>
        </div>
      `;

      // Hide the main cart title when showing empty message
      const mainCartTitle = document.querySelector('.cart > h1');
      if (mainCartTitle) {
        mainCartTitle.style.display = 'none';
      }

      // Hide checkout button when cart is empty
      const checkoutButton = document.querySelector('.cart__checkout-button');
      if (checkoutButton) {
        checkoutButton.style.display = 'none';
      }

      // Hide cart footer when cart is empty
      const cartFooter = document.querySelector('.cart__footer');
      if (cartFooter) {
        cartFooter.style.display = 'none';
      }
    }
  },

  // Open cart modal
  openCart() {
    console.log('Opening cart...');
    const cartModal = document.getElementById('cartModal');
    if (cartModal) {
      cartModal.style.setProperty('display', 'block', 'important');
      this.loadCart();
    } else {
      window.location.href = '/cart';
    }
  },

  // Close cart modal
  closeCart() {
    const cartModal = document.getElementById('cartModal');
    if (cartModal) {
      cartModal.style.setProperty('display', 'none', 'important');
    }
  },

  // Load cart contents
  loadCart() {
    console.log('Loading cart...');
    const cartItems = document.getElementById('cartItems');
    if (!cartItems) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(async cart => {
        const items = await Promise.all(cart.items.map(async item => {
          const handle = item.handle || item.product_handle;
          if (!handle) return item;
          try {
            const response = await fetch(`/products/${handle}.js`);
            if (!response.ok) return item;
            const product = await response.json();
            const variant = product.variants.find(candidate => Number(candidate.id) === Number(item.variant_id));
            return {...item, compare_at_price: Number(variant?.compare_at_price) || 0};
          } catch (error) {
            return item;
          }
        }));
        return {...cart, items};
      })
      .then(cart => {
        console.log('Cart data:', cart);

        if (cart.item_count > 0) {
          let html = '';
          cart.items.forEach((item, index) => {
            const formatMoney = (amount) => `\u20B4${(amount / 100).toFixed(2)}`;
            const originalPrice = Math.max(Number(item.original_price), Number(item.compare_at_price) || 0);
            const hasDiscountedPrice = Number(item.final_price) < originalPrice;
            const priceHtml = hasDiscountedPrice
              ? `<p class="cart-item-price cart-item-price--discounted"><span class="cart-item-price__final">${formatMoney(item.final_price)}</span><s class="cart-item-price__original">${formatMoney(originalPrice)}</s></p>`
              : `<p class="cart-item-price">${formatMoney(item.final_price)}</p>`;
            const discountsHtml = (item.discounts || [])
              .map((discount) => `<p class="cart-item-discount-name">${discount.title} (-${formatMoney(discount.amount)})</p>`)
              .join('');
            html += `
              <div class="cart-item">
                <img src="${item.image}" alt="${item.title}">
                <div class="cart-item-details">
                  <h3><a href="${item.url}" class="cart-item__name">${item.title}</a></h3>
                  ${priceHtml}
                  ${discountsHtml}
                  ${item.variant_title ? `<p>Size: ${item.variant_title}</p>` : ''}
                  <div class="cart-item-quantity">
                    <button onclick="ShopifyCart.changeQuantity(${index}, ${item.variant_id}, -1)" ${item.quantity <= 1 ? 'disabled' : ''}>-</button>
                    <span>${item.quantity}</span>
                    <button onclick="ShopifyCart.changeQuantity(${index}, ${item.variant_id}, 1)">+</button>
                  </div>
                  <button onclick="ShopifyCart.removeItem(${index}, ${item.variant_id})">Remove</button>
                </div>
              </div>
            `;
          });

          html += `
            <div class="cart-total">
              <h3>Total: ₴${(cart.total_price / 100).toFixed(2)}</h3>
            </div>
            <div style="text-align: center; margin-top: 1rem;">
              <a href="/cart" class="button">View Cart</a>
              <a href="/" class="button">Continue Shopping</a>
            </div>
          `;

          cartItems.innerHTML = html;
        } else {
          cartItems.innerHTML = `
            <div style="text-align: center; padding: 2rem;">
              <p style="margin-bottom: 1rem;">Your cart is empty</p>
              <a href="/" class="button">Start Shopping</a>
            </div>
          `;
        }
      })
      .catch(error => {
        console.error('Error loading cart:', error);
        cartItems.innerHTML = `
          <div style="text-align: center; padding: 2rem;">
            <p style="margin-bottom: 1rem;">Error loading cart</p>
            <a href="/cart" class="button">View Cart</a>
          </div>
        `;
      });
  },

  // Change item quantity
  async changeQuantity(index, variantId, change) {
    console.log('Changing quantity:', index, variantId, change);
    console.log('Variant ID type:', typeof variantId);
    console.log('Variant ID value:', variantId);

    // Add loading state
    const button = event.target;
    const originalText = button.innerHTML;
    button.classList.add('cart-button-loading');
    button.disabled = true;

    // Optimistic UI update - change immediately
    const cartItem = button.closest('tr.cart-item');
    const quantityInput = cartItem.querySelector('.quantity__input');
    const currentQuantity = parseInt(quantityInput.value);
    const newQuantity = Math.max(1, currentQuantity + change);

    console.log('Current quantity:', currentQuantity);
    console.log('New quantity:', newQuantity);

    // Update UI immediately
    quantityInput.value = newQuantity;

    // Update button states
    const decreaseButton = cartItem.querySelector('[data-action="decrease"]');
    const increaseButton = cartItem.querySelector('[data-action="increase"]');

    if (decreaseButton) {
      decreaseButton.disabled = newQuantity <= 1;
    }

    // Update line price immediately
    const linePriceElement = cartItem.querySelector('.cart-item__totals span');
    if (linePriceElement) {
      const priceText = linePriceElement.textContent;
      console.log('Original price text:', priceText);

      // Calculate unit price from current total and quantity
      const currentTotal = parseFloat(priceText.replace(/[^\d.]/g, ''));
      const unitPrice = currentTotal / currentQuantity;
      const newLinePrice = (unitPrice * newQuantity).toFixed(2);

      console.log('Unit price:', unitPrice);
      console.log('New line price:', newLinePrice);

      linePriceElement.textContent = `$${newLinePrice}`;
    }

    // Show immediate feedback
    this.showMessage(`Quantity updated to ${newQuantity}`, 'success');

    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart');
      }
      const cart = await cartResponse.json();
      console.log('Current cart:', cart);

      const item = cart.items[index];
      if (!item) {
        console.error('Item not found');
        this.showMessage('Item not found in cart', 'error');
        return;
      }

      console.log('Found item:', item);
      console.log('Item key:', item.key);
      console.log('Item variant_id:', item.variant_id);

      const requestBody = {
        id: variantId,
        quantity: newQuantity
      };
      console.log('Request body:', requestBody);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (response.ok) {
        const result = await response.json();
        console.log('Quantity changed:', result);

        // Update cart count in background
        this.updateCartCount();

        // Update total price if on cart page
        this.updateCartTotal();

      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Error response:', errorData);

        // Revert optimistic update on error
        quantityInput.value = currentQuantity;
        if (linePriceElement) {
          const unitPrice = parseFloat(linePriceElement.textContent.replace(/[^\d.]/g, '')) / newQuantity;
          const originalLinePrice = (unitPrice * currentQuantity).toFixed(2);
          linePriceElement.textContent = `$${originalLinePrice}`;
        }
        if (decreaseButton) {
          decreaseButton.disabled = currentQuantity <= 1;
        }

        throw new Error(errorData.description || 'Failed to update quantity');
      }
    } catch (error) {
      console.error('Error changing quantity:', error);
      this.showMessage(error.message || 'Failed to update quantity', 'error');
    } finally {
      // Remove loading state
      button.classList.remove('cart-button-loading');
      button.disabled = false;
      button.innerHTML = originalText;
      }
  },

  // Update quantity directly (for input field changes)
  async updateQuantityDirect(variantId, newQuantity) {
    console.log('Updating quantity directly:', variantId, newQuantity);

    if (newQuantity < 0) {
      this.showMessage('Quantity cannot be negative', 'error');
      return;
    }

    // Find the input element
    const input = event.target;
    const originalValue = input.value;
    const cartItem = input.closest('tr.cart-item');

    console.log('Original value:', originalValue);
      console.log('New quantity:', newQuantity);

    // Optimistic UI update
    input.value = newQuantity;

    // Update line price immediately
    const linePriceElement = cartItem.querySelector('.cart-item__totals span');
    if (linePriceElement) {
      const priceText = linePriceElement.textContent;
      console.log('Original price text:', priceText);

      // Calculate unit price from current total and quantity
      const currentTotal = parseFloat(priceText.replace(/[^\d.]/g, ''));
      const unitPrice = currentTotal / originalValue;
      const newLinePrice = (unitPrice * newQuantity).toFixed(2);

      console.log('Unit price:', unitPrice);
      console.log('New line price:', newLinePrice);

      linePriceElement.textContent = `$${newLinePrice}`;
    }

    // Update button states
    const decreaseButton = cartItem.querySelector('[data-action="decrease"]');
    const increaseButton = cartItem.querySelector('[data-action="increase"]');

    if (decreaseButton) {
      decreaseButton.disabled = newQuantity <= 1;
    }

    // Show immediate feedback
    this.showMessage(`Quantity updated to ${newQuantity}`, 'success');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Quantity updated:', result);

        // Update cart count in background
        this.updateCartCount();

        // Update total price if on cart page
        this.updateCartTotal();

      } else {
        const errorData = await response.json().catch(() => ({}));

        // Revert optimistic update on error
        input.value = originalValue;
        if (linePriceElement) {
          const unitPrice = parseFloat(linePriceElement.textContent.replace(/[^\d.]/g, '')) / newQuantity;
          const originalLinePrice = (unitPrice * originalValue).toFixed(2);
          linePriceElement.textContent = `$${originalLinePrice}`;
        }
        if (decreaseButton) {
          decreaseButton.disabled = originalValue <= 1;
        }

        throw new Error(errorData.description || 'Failed to update quantity');
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
      this.showMessage(error.message || 'Failed to update quantity', 'error');
    }
  },

  // Update quantity method for inline calls
  updateQuantity(index, variantId, newQuantity) {
    this.updateQuantityDirect(variantId, parseInt(newQuantity));
  },

  // Remove item
  async removeItem(index, variantId) {
    console.log('Removing item:', index, variantId);
    console.log('Variant ID type:', typeof variantId);
    console.log('Variant ID value:', variantId);

    // Add loading state
    const button = event.target;
    const originalText = button.textContent;
    button.classList.add('cart-button-loading');
    button.disabled = true;
    button.textContent = 'Removing...';

    // Optimistic UI update - hide item immediately
    const cartItem = button.closest('tr.cart-item');

    if (cartItem) {
      console.log('Found cart item row:', cartItem);

      // Add fade out animation
      cartItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      cartItem.style.opacity = '0';
      cartItem.style.transform = 'translateX(-20px)';

      // Remove from DOM after animation
      setTimeout(() => {
        cartItem.remove();

        // Update total price
        this.updateCartTotal();

        // Check if cart is empty
        const remainingItems = document.querySelectorAll('tr.cart-item');
        console.log('Remaining items:', remainingItems.length);

        if (remainingItems.length === 0) {
          this.showEmptyCartMessage();
        } else {
          // Show the main cart title when cart has items
          const mainCartTitle = document.querySelector('.cart > h1');
          if (mainCartTitle) {
            mainCartTitle.style.display = 'block';
          }

          // Show checkout button when cart has items
          const checkoutButton = document.querySelector('.cart__checkout-button');
          if (checkoutButton) {
            checkoutButton.style.display = 'block';
          }

          // Show cart footer when cart has items
          const cartFooter = document.querySelector('.cart__footer');
          if (cartFooter) {
            cartFooter.style.display = 'block';
          }
        }
      }, 300);
    } else {
      console.error('Cart item row not found');
    }

    // Show immediate feedback
    this.showMessage('Item removed from cart', 'success');

    try {
      const requestBody = {
        id: variantId,
        quantity: 0
      };
      console.log('Remove request body:', requestBody);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      console.log('Remove response status:', response.status);
      console.log('Remove response ok:', response.ok);

      if (response.ok) {
        const result = await response.json();
        console.log('Item removed:', result);

        // Update cart count in background
        this.updateCartCount();

      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Remove error response:', errorData);

        // Revert optimistic update on error
        if (cartItem) {
          cartItem.style.opacity = '1';
          cartItem.style.transform = 'translateX(0)';
        }

        throw new Error(errorData.description || 'Failed to remove item');
      }
    } catch (error) {
      console.error('Error removing item:', error);

      // Revert optimistic update on error
      if (cartItem) {
        cartItem.style.opacity = '1';
        cartItem.style.transform = 'translateX(0)';
      }

      this.showMessage(error.message || 'Failed to remove item', 'error');
    } finally {
      // Remove loading state
      button.classList.remove('cart-button-loading');
      button.disabled = false;
      button.textContent = originalText;
    }
  },

  // Reload page to update cart display
  reloadPage() {
    // Only reload if we're on the cart page
    if (window.location.pathname === '/cart') {
      window.location.reload();
    }
  },

  // Show message
  showMessage(message, type = 'success') {
    console.log('Showing message:', message, type);

    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cart-message');
    existingMessages.forEach(msg => {
      msg.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => msg.remove(), 300);
    });

    const messageEl = document.createElement('div');
    messageEl.className = `cart-message cart-message-${type}`;
    messageEl.textContent = message;

    document.body.appendChild(messageEl);

    // Hide message after 3 seconds with smooth animation
    setTimeout(() => {
      messageEl.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => {
        messageEl.remove();
      }, 300);
    }, 3000);
  },

  // Update cart total price
  updateCartTotal() {
    const cartItems = document.querySelectorAll('tr.cart-item');
    let total = 0;

    cartItems.forEach(item => {
      const linePriceElement = item.querySelector('.cart-item__totals span');
      if (linePriceElement) {
        const priceText = linePriceElement.textContent;
        console.log('Price text:', priceText);

        // Extract price value (remove currency symbol and commas)
        const price = parseFloat(priceText.replace(/[^\d.]/g, ''));
        console.log('Parsed price:', price);

        if (!isNaN(price)) {
          total += price;
        }
      }
    });

    console.log('Calculated total:', total);

    const totalElement = document.querySelector('.totals__subtotal-value');
    if (totalElement) {
      // Add animation class
      totalElement.classList.add('updating');

      // Update the value
      totalElement.textContent = `₴${total.toFixed(2)}`;

      // Remove animation class after animation completes
      setTimeout(() => {
        totalElement.classList.remove('updating');
      }, 600);
    } else {
      console.error('Total element not found');
    }
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM ready, initializing cart');
  window.ShopifyCart.init();
});

// Also initialize on window load as backup
window.addEventListener('load', () => {
  if (!window.ShopifyCart) {
    console.log('ShopifyCart not found, initializing');
    window.ShopifyCart.init();
  }
});
